import { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Box,
  Text,
  Skeleton,
} from '@chakra-ui/react';
import { getQuizzes } from './hooks/protocol.hooks';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onResponder: (item: any) => void;
}

export const ProtocolsModal = ({ isOpen, onClose, onResponder }: Props) => {
  const [loading, setLoading] = useState(true);
  const [quizzes, setQuizzes] = useState<any>(null);

  const GetData = async () => {
    setLoading(true);
    try {
      const data = await getQuizzes();
      setQuizzes(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetData();
  }, []);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="5xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Lista de Protocolos</ModalHeader>
        <ModalCloseButton />

        <ModalBody pb={6}>
          {loading ? (
            <Skeleton mt="8" w="100%" h="200px" border="20px" />
          ) : quizzes && quizzes.length > 0 ? (
            <Table>
              <Thead>
                <Tr>
                  <Th>Nome</Th>
                  <Th>Data</Th>
                  <Th>Profissional</Th>
                  <Th>Ação</Th>
                </Tr>
              </Thead>

              <Tbody>
                {quizzes.map((item: any) => (
                  <Tr>
                    <Td>{item.descricao}</Td>
                    <Td>{item.dataInicial}</Td>
                    <Td>{item.prof || '-'}</Td>
                    <Td>
                      <Button
                        size="sm"
                        color="white"
                        bg="#60C2B0"
                        onClick={() => {
                          onResponder(item);
                        }}
                      >
                        Responder
                      </Button>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          ) : (
            <Box
              width="100%"
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              padding={10}
            >
              <Text
                fontSize="lg"
                w="100%"
                color="brand-dark.300"
                fontFamily="Rubik"
                paddingBottom="19"
                margin="auto"
                textAlign="center"
              >
                NÃO HÁ QUESTIONÁRIOS PARA ESTE PACIENTE
              </Text>
            </Box>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
